import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { I18N_NAMESPACE, SUPPORTED_LOCALE } from "@kivunova/kivufrontendcommon";

// Webpack uses process.env with REACT_APP_ prefix
const S3_BASE_URL =
  process.env.REACT_APP_S3_TRANSLATION_BUCKET ||
  "https://default-bucket.s3.amazonaws.com";

const DEFAULT_LANG =
  process.env.REACT_APP_S3_DEFAULT_LANG || SUPPORTED_LOCALE[0];

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANG,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LOCALE,
    fallbackNS: false,
    ns: [I18N_NAMESPACE],
    defaultNS: I18N_NAMESPACE,
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `${S3_BASE_URL}/i18n/{{lng}}/{{ns}}.json`
    }
  });

export default i18n;
